import { ThunkAction } from 'redux-thunk';
import { RootState } from '../..';
import firebase from '../../../config/firebase';
import { Article } from '../../constants/narrationConstants';
import { SignUpData, AuthAction, SET_USER, User, SET_PLAYLIST, SET_LOADING, SIGN_OUT, SignInData, SET_ERROR, NEED_VERIFICATION, SET_SUCCESS, CREATE_ANON, SET_TOKEN } from '../../constants/authConstants';

// Create user
export const signup = (data: SignUpData, onError: () => void): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            const res = await firebase.auth().createUserWithEmailAndPassword(data.email, data.password);
            if(res.user) {
                const userData: User = {
                    email: data.email,
                    firstName: data.firstName,
                    id: res.user.uid,
                    isAnonymous: false,
                    created: firebase.firestore.FieldValue.serverTimestamp()
                };
                await firebase.firestore().collection('/users').doc(res.user.uid).set(userData);
                await res.user.sendEmailVerification();
                dispatch({
                    type: NEED_VERIFICATION
                });
                dispatch({
                    type: SET_USER,
                    payload: userData
                });
            }
        } catch (err) {
            console.log(err);
            onError();
            dispatch({
                type: SET_ERROR,
                payload: err.message
            });
        }
    }
};

// Get user by id
export const getUserById = (id: string): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            console.log("getting user");
            const user = await firebase.firestore().collection('users').doc(id).get();
            if(user.exists) {
                console.log("user Exists");
                const userData = user.data() as User;
                if(!userData.isAnonymous) {
                    dispatch({
                        type: SET_USER,
                        payload: userData
                    });
                } else {
                    console.log("user User is Anonymous");
                }
            } else {
                console.log("user does not exist");
            }
        } catch (err) {
            console.log(err);
        }
    }
};

// Set loading
export const setLoading = (value: boolean): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_LOADING,
            payload: value
        });
    }
};

// Log in
export const signin = (data: SignInData, onError: () => void): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            await firebase.auth().signInWithEmailAndPassword(data.email, data.password);
        } catch (err) {
            console.log(err);
            onError();
            dispatch(setError(err.message));
        }
    }
};

// Log out
export const signout = (): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            dispatch(setLoading(true));
            await firebase.auth().signOut();
            dispatch({
                type: SIGN_OUT
            });
        } catch (err) {
            console.log(err);
            dispatch(setLoading(false));
        }
    }
};

// Set error
export const setError = (msg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_ERROR,
            payload: msg
        });
    }
};

// Set need verification
export const setNeedVerification = (): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: NEED_VERIFICATION
        });
    }
};

// Set success
export const setSuccess = (msg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_SUCCESS,
            payload: msg
        });
    }
};

// Set Auth Token
export const setToken = (token: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_TOKEN,
            payload: token
        });
    }
};

// Send password reset email
export const sendPasswordResetEmail = (email: string, successMsg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            await firebase.auth().sendPasswordResetEmail(email);
            dispatch(setSuccess(successMsg));
        } catch (err) {
            console.log(err);
            dispatch(setError(err.message));
        }
    }
};

// Send password reset email
export const anonymousLogin = (): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            dispatch(setLoading(true));
            const res = await firebase.auth().signInAnonymously();
            const authToken = (await res?.user?.getIdToken())?.toString() as string;
            dispatch(setToken(authToken));
            if(res.user) {
                const userData: User = {
                    email: "anonymous@getnalij.com",
                    firstName: "AnonymousUser",
                    id: res.user.uid,
                    isAnonymous: true,
                    created: firebase.firestore.FieldValue.serverTimestamp(),
                };

                //await firebase.firestore().collection('/users').doc(res.user.uid).set(userData);

                // Production VS Local Dev API
                let api_user_url = "";
                if ( window.location.hostname === 'localhost') {
                    const path = 'http://localhost:5001/nalij-api/us-central1/app/';
                    api_user_url = path + '/api/user';
                } else {
                    // production code
                    api_user_url =  '/api/user';
                }
                console.log("YURL NONYMUSS LAGIN");
                await fetch(api_user_url, {
                    method: 'post',
                    headers: new Headers({
                        'auth-token': authToken
                    }),
                    body: JSON.stringify({user:userData})
                });

                dispatch({
                    type: CREATE_ANON,
                    payload: userData
                });
            }
        } catch (err) {
            console.log(err);
            dispatch(setError(err.message));
        }
    }
};

// Set loading
export const setPlayList = (token: string): ThunkAction<void, RootState, null, AuthAction> => {
    let articles:Array<Article>;
    return dispatch => {
        console.log("PRE DISPATCH", token);
        //dispatch(setLoading(true));
        if(token) {console.log("PLAYLIST DISPATCHED");
            ( async () => {console.log("start async");
                let api_url = "";
                if ( window.location.hostname === 'localhost') {
                    const path = 'http://localhost:5001/nalij-api/us-central1/app/';
                    api_url = path + '/api/playlist';
                } else {
                    // production code
                    api_url = '/api/playlist';
                }
                console.log("zFetch");
                const response = await fetch(api_url, {
                    method: 'get',
                    headers: new Headers({
                        'auth-token': token
                    })
                });

                console.log("waiting on articles");
                articles = await response.json();
                console.log("Articles arrived");
                //dispatch(setLoading(false));

                dispatch({
                    type: SET_PLAYLIST,
                    payload: articles
                });
            })();
        }
    }
};

